import { OverlayModule } from "@angular/cdk/overlay";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { NzNoAnimationModule } from "ng-zorro-antd/core/no-animation";
import { UiAutocompleteComponent } from "@webapp/ui/autocomplete/autocomplete.component";
import { UiAutocompleteOptgroupComponent } from "@webapp/ui/autocomplete/components/autocomplete-optgroup/autocomplete-optgroup.component";
import { UiAutocompleteOptionComponent } from "@webapp/ui/autocomplete/components/autocomplete-option/autocomplete-option.component";
import { UiAutocompleteTriggerDirective } from "@webapp/ui/autocomplete/directives/autocomplete-trigger.directive";
import { UiInputModule } from "@webapp/ui/input/input.module";

@NgModule({
  imports: [CommonModule, UiInputModule, OverlayModule, NzNoAnimationModule],
  declarations: [UiAutocompleteComponent, UiAutocompleteOptionComponent, UiAutocompleteTriggerDirective, UiAutocompleteOptgroupComponent],
  exports: [UiAutocompleteComponent, UiAutocompleteOptionComponent, UiAutocompleteTriggerDirective, UiAutocompleteOptgroupComponent],
})
export class UiAutocompleteModule {}
